import { rootStore } from '../provider/StoreProvider'

// 각 탭 별로 사용되는 url 주소들 모음
const HOME_PATHS = ['/home', '/sellHistory']
const MARKET_PATHS = ['/market']
const CONTENTS_PATHS = ['/contents']
const MY_PAGE_PATHS = ['/myPage']
const SETTING_PATHS = [
  '/signUp',
  '/signIn',
  '/setting',
  '/notify',
  '/notice',
  '/event',
  '/disclosure',
  '/faq',
  '/qna',
  '/personalInfo',
  '/address',
  '/account',
  '/withdrawalAccount',
  '/depositAccount',
  '/push',
  '/withdrawalUser',
]

export function toggleTab(pathname: string) {
  if (HOME_PATHS.includes(pathname)) {
    rootStore.commonStore.setActiveTab('home')
    return
  }
  if (MARKET_PATHS.includes(pathname)) {
    rootStore.commonStore.setActiveTab('market')
    return
  }
  if (CONTENTS_PATHS.includes(pathname)) {
    rootStore.commonStore.setActiveTab('contents')
    return
  }
  if (MY_PAGE_PATHS.includes(pathname)) {
    rootStore.commonStore.setActiveTab('myPage')
    return
  }
  if (SETTING_PATHS.includes(pathname)) {
    rootStore.commonStore.setActiveTab('setting')
    return
  }
}
